import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button, Row, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { RESET_EMAIL_URL } from '../../actions/url';

const propTypes = {
  onCloseClicked: PropTypes.func.isRequired,
  selectedUserId: PropTypes.string.isRequired,
};

class ResetEmailModal extends Component {
  constructor() {
    super();
    this.state = {
      inputText: '',
      errors: '',
    };
  }

  resetEmail = (email) => {
    let errors = ''

    // check validation
    if (!email) {
      errors = 'Email field cannot be empty';
    } else if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
      errors = 'Email is not valid';
    }

    const url = RESET_EMAIL_URL + this.props.selectedUserId;
    if (errors === '') {
      axios.put(
        url,
        {
          email,
        },
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        },
      ).then((response) => {
        if (response.status === 200) {
          alert(`Reset email to: ${email}`);
        }
        this.props.onCloseClicked();
        this.setState({
          errors: '',
        });
      })
        .catch((error) => {
          alert('Could not reset email, please try again!');
        });
    } else {
      this.setState({ errors });
    }
  };

  render() {
    const { inputText, errors } = this.state;
    return (
      <div>
        <Row>
          <div className="text-center" style={{ marginTop: '20px' }}>
            <h3><Translate value="type_in_your_email" /></h3>
          </div>
        </Row>
        <Row>
          <div className="col-xs-4 col-xs-offset-4">
            <Input
              type="email"
              onChange={event => this.setState({ inputText: event.target.value })}
            />
          </div>
          <div className="col-xs-1 col-xs-offset-5" style={{ marginTop: '50px' }}>
            <Button
              bsStyle="primary"
              onClick={() => { this.resetEmail(inputText); }}
            >
              <em className="fa fa-check" /><Translate value="Confirm" />
            </Button>
          </div>
        </Row>
        <br />
        <Row>
          {errors !== '' && <div className="alert alert-danger"><Translate value={errors} /></div>}
        </Row>
      </div>
    );
  }
}

ResetEmailModal.propTypes = propTypes;
export default ResetEmailModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/ResetEmailModal.jsx